import { css } from "@emotion/react";

export const content = css`
  white-space: pre-line;
  padding-top: 1rem;
  p:not(:last-child) {
    margin-bottom: 0;
  }
  ul,
  ol {
    margin-top: 0;
    padding-top: 0;
  }
`;
